import * as React from 'react';
import styled from 'styled-components';

interface DataRowsProps {
	rows: Record<string, any>[];
	rowClassName: string | ((record: Record<string, any>, index: number) => string);
	totalWidth: number;
}

export const RowPlaceholder = styled.div`
	width: 100%;
	padding: 1em 0;
	display: grid;
	place-items: center;
`;

export const useDebugUnmount = (name: string) => {
	console.log(`${name} rendered`);

	React.useEffect(() => {
		console.log(`${name} MOUNTED`);
		return () => console.log(`${name} UNMOUNTED`);
	}, []);
};
